// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {buildDate} from '../../../../shared/services/build-date';

const AmountOfUseRequestPanelItem = props =>
    <section className='amount-of-use-request-item'>
        <span className='request'>{props.id}</span>
        <span className='date'>{buildDate(props.date)}</span>
        <span className='amountOfUse'>{props.amountOfUse}</span>
        <span className='status'>{props.status}</span>
        <span className='tcsmComments'>{props.commentsToDealer}</span>
    </section>;

AmountOfUseRequestPanelItem.displayName = 'AmountOfUseRequestPanelItem';
AmountOfUseRequestPanelItem.propTypes = {
    amountOfUse: PropTypes.string.isRequired,
    commentsToDealer: PropTypes.string.isRequired,
    date: PropTypes.number.isRequired,
    id: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired
};

export default AmountOfUseRequestPanelItem;



// WEBPACK FOOTER //
// ./src/product/details/components/amount-of-use-history-panel/amount-of-use-request-panel-item.js